<template>
  <div class="infoBasic">
    <div>
      <div>
        <div class="recruitText bl">公司名称：</div>
        <div class="recruitText c666">
          壹心保险代理（浙江）有限公司
        </div>
      </div>
      <div style="margin-top:30px;">
        <div class="recruitText bl">经营地址：</div>
        <div class="recruitText c666">
          浙江省嘉兴市经济技术开发区商务金融大厦1幢办C601室-B室
        </div>
      </div>
      <div style="margin-top:30px;">
        <div class="recruitText bl">经营范围：</div>
        <div class="recruitText c666">
          在浙江省行政辖区内代理销售保险产品；代理收取保险费；代理相关保险业务的损失勘查和理赔；中国银保监会批准的其他业务。
        </div>
      </div>
      <div style="margin-top:30px;">
        <div class="recruitText bl">公司变更情况：</div>
        <div class="recruitText c666">
          公司于2018年10月16日经嘉兴市市场监督管理局核准，由北京壹心壹翼科技有限公司收购台州亨合保险代理有限公司。更名为壹心保险代理(浙江)有限公司。
        </div>
      </div>
      <div style="margin-top:30px;">
        <div class="recruitText bl">证照资质：</div>
        <div class="recruitText">
          <a href="https://prd-imc.oss-cn-beijing.aliyuncs.com/%E5%A3%B9%E5%BF%83%E4%BF%9D%E9%99%A9%E4%BB%A3%E7%90%86-%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7.pdf"
            target="_blank" style="color:#EAA12C;">工商营业执照</a>&nbsp;&nbsp;
          <a href="https://prd-imc.oss-cn-beijing.aliyuncs.com/%E5%A3%B9%E5%BF%83%E4%BF%9D%E9%99%A9%E4%BB%A3%E7%90%86-%E4%BF%9D%E9%99%A9%E4%B8%AD%E4%BB%8B%E8%AE%B8%E5%8F%AF%E8%AF%81.pdf"
            target="_blank" style="color:#EAA12C;"> 经营保险代理业务许可证</a>
        </div>
      </div>
      <div style="margin-top:30px;">
        <div class="bl">分支机构情况：</div>
        <div class="company">
          <div class="company-title">
            <div class="company-header fz16">
              <p class="company-name"><span>机构</span></p>
              <p class="company-address"><span>经营地址</span></p>
              <p class="company-phone"><span>联系电话</span></p>
            </div>
          </div>
          <ul class="company-list fz12 c666">
            <li class="company-header">
              <p class="company-name"><span>壹心保险代理（浙江）有限公司</span></p>
              <p class="company-address"><span>浙江省嘉兴市经济技术开发区商务金融大厦1幢办C601室-B室</span></p>
              <p class="company-phone"><span>400-000-2266</span></p>
            </li>
            <li class="company-header">
              <p class="company-name"><span>壹心保险代理（浙江）有限公司杭州分公司</span></p>
              <p class="company-address"><span>浙江省杭州市西湖区学院路77号2幢1201室</span></p>
              <p class="company-phone"><span>400-000-2266</span></p>
            </li>
            <li class="company-header">
              <p class="company-name"><span>壹心保险代理（浙江）有限公司桐庐分公司</span></p>
              <p class="company-address"><span>浙江省杭州市桐庐县城南街道迎春南路205号新青年广场1501室-2、1501室-3</span></p>
              <p class="company-phone"><span>400-000-2266</span></p>
            </li>
            <li class="company-header">
              <p class="company-name"><span>壹心保险代理（浙江）有限公司金华分公司</span></p>
              <p class="company-address"><span>浙江省金华市金东区多湖街道宾虹东路358号嘉福商务大厦1幢103、105铺</span></p>
              <p class="company-phone"><span>400-000-2266</span></p>
            </li>
            <li class="company-header">
              <p class="company-name"><span>壹心保险代理（浙江）有限公司义乌分公司</span></p>
              <p class="company-address"><span>浙江省义乌市福田街道银海路399号国际商务中心1101室</span></p>
              <p class="company-phone"><span>400-000-2266</span></p>
            </li>
            <li class="company-header">
              <p class="company-name"><span>壹心保险代理（浙江）有限公司绍兴分公司</span></p>
              <p class="company-address"><span>浙江省绍兴市柯桥区柯桥街道绍兴世界贸易中心（南区）16幢四层B044号</span></p>
              <p class="company-phone"><span>400-000-2266</span></p>
            </li>
            <li class="company-header">
              <p class="company-name"><span>壹心保险代理（浙江）有限公司诸暨分公司</span></p>
              <p class="company-address"><span>浙江省诸暨市陶朱街道西二环路288号外贸大厦20层南区</span></p>
              <p class="company-phone"><span>400-000-2266</span></p>
            </li>
            <li class="company-header">
              <p class="company-name"><span>壹心保险代理（浙江）有限公司海宁分公司</span></p>
              <p class="company-address"><span>浙江省嘉兴市海宁市许村镇人民大道2838号和信大厦5楼501室</span></p>
              <p class="company-phone"><span>400-000-2266</span></p>
            </li>
            <li class="company-header">
              <p class="company-name"><span>壹心保险代理（浙江）有限公司桐乡分公司</span></p>
              <p class="company-address"><span>浙江省嘉兴市桐乡市梧桐街道振兴东路(东)329号东湖金悦小区8幢19层</span></p>
              <p class="company-phone"><span>400-000-2266</span></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'infoBasic',
  components: {},
  data() {
    return {

    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.infoBasic {
  width: 876px;
  box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
  padding: 40px;

  .company {
    margin-top: 20px;
  }

  .recruitText {
    line-height: 26px;
  }

  .company-header {
    min-height: 70px;
    letter-spacing: 1px;
    line-height: 1.5;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  p {
    height: 70px;
    border: 1px solid #f5f5f5;
    display: flex;
    align-items: center;

    span {
      display: inline-block;
    }
  }

  .company-name {
    width: 230px;
    padding-left: 16px;
  }

  .company-address {
    width: 360px;
    padding-left: 16px;
  }

  .company-phone {
    width: 230px;
    padding-left: 16px;
    justify-content: center;
  }

  .company-tip {
    width: 200px;
    padding-left: 16px;
  }

  .company-title {
    .company-header {
      background-color: #EBEBEB;
      font-weight: 600;
    }

    p {
      justify-content: center;
    }
  }
}
</style>